"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.H_C_META = exports.H_AUTH = exports.H_C_ID = exports.isOk = exports.PagedQuery = exports.RpcError = void 0;
const grpc_status_code_1 = require("./grpc-status-code");
class RpcError extends Error {
    constructor(code, message) {
        super(message);
        this.code = code;
    }
}
exports.RpcError = RpcError;
RpcError.CLIENT_INVALID_ARGUMENT = 400;
RpcError.PROXY_ERROR = -1;
class PagedQuery {
    constructor(pageSize, page = 1) {
        this.pageSize = pageSize;
        this.page = page;
    }
}
exports.PagedQuery = PagedQuery;
function isOk(res) {
    return res.code === grpc_status_code_1.GrpcStatusCode.OK;
}
exports.isOk = isOk;
exports.H_C_ID = 'c-id';
exports.H_AUTH = 'authorization';
exports.H_C_META = 'c-meta';
